const MIN_MARKER_WIDTH = 88;
const MAX_MARKER_WIDTH = 280;
const MIN_MARKER_HEIGHT = 44;
const HORIZONTAL_CHROME = 28;
const VERTICAL_CHROME = 20;
const LINE_HEIGHT = 18;
const CJK_PATTERN = /[\u2e80-\u9fff\uf900-\ufaff]/u;

function estimatedGlyphWidth(character) {
  if (CJK_PATTERN.test(character)) return 12;
  if (/\s/u.test(character)) return 4;
  if (/[MW@#%&]/u.test(character)) return 9;
  if (/[A-Z]/u.test(character)) return 8;
  if (/[ilI1.,'`|!]/u.test(character)) return 4;
  return 7;
}

export function navigationMarkerLabel(value) {
  return String(value || '').trim() || '前往';
}

export function navigationMarkerSize(value, availableWidth = MAX_MARKER_WIDTH + 32) {
  const label = navigationMarkerLabel(value);
  const viewportLimit = Number.isFinite(availableWidth)
    ? Math.max(MIN_MARKER_WIDTH, Math.floor(availableWidth) - 32)
    : MAX_MARKER_WIDTH;
  const maximumWidth = Math.min(MAX_MARKER_WIDTH, viewportLimit);
  const estimatedTextWidth = Array.from(label).reduce(
    (total, character) => total + estimatedGlyphWidth(character),
    0
  );
  const width = Math.min(
    maximumWidth,
    Math.max(MIN_MARKER_WIDTH, Math.ceil(estimatedTextWidth + HORIZONTAL_CHROME))
  );
  const contentWidth = Math.max(1, width - HORIZONTAL_CHROME);
  const lineCount = Math.max(1, Math.ceil(estimatedTextWidth / contentWidth));
  const height = Math.max(MIN_MARKER_HEIGHT, VERTICAL_CHROME + lineCount * LINE_HEIGHT);

  return { width, height };
}
